import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PartnerEmailTemplate,
  RecipientCategory,
  EmailBroadCast,
  EmailBroadCastInput,
  PartnerBulkEmailTemplateDetails
} from '../../models/email-broadcast.model';
import { EngagementSearchAndFilterInput } from '../../models/engagement-search-and-filter-input.model';
import { EngagmentCountModel } from '../../models/engagment-count.model';
import { FeatureFlagType } from '../../models/feature-flag.model';
import {
  MarketingBanner,
  MarketingBannerMessage,
  MarketingBannerHistory
} from '../../models/marketing-banner.model';
import { MSAIExceptionDisputeRequests } from '../../models/msai-exception-dispute-requests.model';
import { MSAIExceptionDisputeSearchAndFilterInput } from '../../models/msai-exception-dispute-search-and-filter-input.model';
import {
  NotificationBannerMessage,
  NotificationBannerHistory
} from '../../models/notification-banner.model';
import { PagedResult } from '../../models/page-result.model';
import { PartnerBulkEmailTracking } from '../../models/partner-bulk-email-tracking.model';
import { PartnerInput } from '../../models/partner-input.model';
import {
  PrivateWorkshopHistory,
  PartnerListUploadItem,
  CustomerListImportItem
} from '../../models/private-workshop-response.model';
import { RequestDetails } from '../../models/request-details.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class OsmosisService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  getLoggedInUserName(): Observable<any> {
    return this.http.get(
      this.settings.baseUrl + 'api/users/GetLoggedInUserName'
    );
  }

  getAllList(): Observable<PartnerInput[]> {
    return this.http.get<PartnerInput[]>(
      this.settings.baseUrl + 'api/M365acceleratorNominations/GetAll'
    );
  }

  searchEngagements(
    searchAndFilterModel: EngagementSearchAndFilterInput
  ): Observable<PagedResult<PartnerInput>> {
    return this.http.post<PagedResult<PartnerInput>>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/SearchEngagements',
      searchAndFilterModel
    );
  }
  searchEngagementsForSpecialInvestments(
    searchAndFilterModel: EngagementSearchAndFilterInput
  ): Observable<PagedResult<PartnerInput>> {
    return this.http.post<PagedResult<PartnerInput>>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/SearchEngagementsForSpecialInvestments',
      searchAndFilterModel
    );
  }

  searchEngagementsForAdvoicerIncentives(
    searchAndFilterModel: EngagementSearchAndFilterInput
  ): Observable<PagedResult<PartnerInput>> {
    return this.http.post<PagedResult<PartnerInput>>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/SearchEngagementsForAdvoicerIncentives',
      searchAndFilterModel
    );
  }

  searchMSAIExceptionDisputeRequests(
    searchAndFilterModel: MSAIExceptionDisputeSearchAndFilterInput
  ): Observable<PagedResult<MSAIExceptionDisputeRequests>> {
    return this.http.post<PagedResult<MSAIExceptionDisputeRequests>>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/SearchMSAIExceptionDisputeRequests',
      searchAndFilterModel
    );
  }

  getEngagementsForSpecialInvestments(
    tabName: string
  ): Observable<PartnerInput[]> {
    return this.http.get<PartnerInput[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetEngagementsForSpecialInvestments/' +
        tabName
    );
  }

  getEngagementsForCustomerAckReview(): Observable<PartnerInput[]> {
    return this.http.get<PartnerInput[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetEngagementsForCustomerAckReview'
    );
  }

  getFactDataByRequestDetails(
    requestDetailId: number
  ): Observable<RequestDetails> {
    return this.http.get<RequestDetails>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetFactDataByRequestDetailId/RequestDetailId/' +
        requestDetailId
    );
  }

  export1(): Observable<any[]> {
    return Observable.create(observer => {
      const xhr = new XMLHttpRequest();
      xhr.open(
        'GET',
        this.settings.baseUrl + 'api/M365acceleratorNominations/ExportToExcel',
        true
      );
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.responseType = 'blob';

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            const contentType =
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const blob = new Blob([xhr.response], { type: contentType });
            observer.next(blob);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.send();
    });
  }

  export2(): Observable<HttpResponse<Blob>> {
    return this.http.get<Blob>(
      this.settings.baseUrl + 'api/M365acceleratorNominations/ExportToExcel',
      { responseType: 'blob' as 'json', observe: 'response' }
    );
  }

  export3(): Observable<any[]> {
    return this.http.get<any[]>(
      this.settings.baseUrl + 'api/M365acceleratorNominations/ExportToExcel'
    );
  }

  public export(): Observable<any[]> {
    const headers = new HttpHeaders().set(
      'content-type',
      'application/octet-stream'
    );
    return this.http.get<any[]>(
      this.settings.baseUrl + 'api/M365acceleratorNominations/ExportToExcel',
      { headers, responseType: 'blob' as 'json' }
    );
  }

  getEngagementCountRequiringAction(): Observable<EngagmentCountModel> {
    return this.http.get<EngagmentCountModel>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetEngagementCountRequiringAction'
    );
  }
  getActivitiesCountRequiringAction(): Observable<EngagmentCountModel> {
    return this.http.get<EngagmentCountModel>(
      `${this.settings.baseUrl}api/M365acceleratorNominations/GetActivitiesCountRequiringAction`
    );
  }

  getEngagementsForPoeDocReview(): Observable<PartnerInput[]> {
    return this.http.get<PartnerInput[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetEngagementsForPOEDocReview'
    );
  }

  getEngagementsForInvoiceReview(): Observable<PartnerInput[]> {
    return this.http.get<PartnerInput[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetEngagementsForInvoiceReview'
    );
  }

  getEngagementsForCustomerSurveyReview(): Observable<PartnerInput[]> {
    return this.http.get<PartnerInput[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetEngagementsForCustomerSurveyReview'
    );
  }

  getPrivateWorkshopHistory(
    workshopType: number,
    page?: number
  ): Observable<PrivateWorkshopHistory[]> {
    const pgIdx = page ? page : 0;
    return this.http.get<PrivateWorkshopHistory[]>(
      `${this.settings.baseUrl}api/PrivateWorkshop/GetHistory/${workshopType}?page=${pgIdx}`
    );
  }

  validatePrivateWorkshopPartnerList(
    workshopType: number,
    partnerExcelFile: any
  ): Observable<PartnerListUploadItem> {
    return this.http.post<PartnerListUploadItem>(
      `${this.settings.baseUrl}api/PrivateWorkshop/ValidatePartnerAccessList/${workshopType}`,
      partnerExcelFile
    );
  }

  uploadPrivateWorkshopPartnerList(
    workshopType: number,
    partnerExcelFile: any
  ): Observable<PartnerListUploadItem> {
    return this.http.post<PartnerListUploadItem>(
      `${this.settings.baseUrl}api/PrivateWorkshop/UploadPartnerList/${workshopType}`,
      partnerExcelFile
    );
  }

  validatePrivateWorkshopCustomerList(
    workshopType: number,
    partnerExcelFile: any
  ): Observable<CustomerListImportItem> {
    return this.http.post<CustomerListImportItem>(
      `${this.settings.baseUrl}api/PrivateWorkshop/ValidateCustomerList/${workshopType}`,
      partnerExcelFile
    );
  }

  uploadPrivateWorkshopCustomerList(
    workshopType: number,
    customerExcelFile: any
  ): Observable<CustomerListImportItem> {
    return this.http.post<CustomerListImportItem>(
      `${this.settings.baseUrl}/api/PrivateWorkshop/UploadCustomerList/${workshopType}`,
      customerExcelFile
    );
  }

  isFeatureEnabled(
    featureFlagType: FeatureFlagType,
    programTypeId: number
  ): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.settings.baseUrl}/api/FeatureFlag/GetFeature/${featureFlagType}/${programTypeId}`
    );
  }

  updateFeature(
    featureFlagType: FeatureFlagType,
    isActive: boolean,
    programTypeId: number
  ): Observable<string> {
    return this.http.post<string>(
      `${this.settings.baseUrl}/api/FeatureFlag/UpdateFeature/${featureFlagType}/${isActive}/${programTypeId}`,
      null
    );
  }

  getNotificationBanner(programTypeId: number): Observable<string> {
    return this.http.get<string>(
      `${this.settings.baseUrl}/api/Notification/GetNotificationBanner?programTypeId=${programTypeId}`
    );
  }

  updateNotificationBanner(
    notificationBannerMessage: NotificationBannerMessage
  ): Observable<string> {
    return this.http.post<string>(
      `${this.settings.baseUrl}/api/Notification/UpdateNotificationBanner`,
      notificationBannerMessage
    );
  }

  getMarketingBanner(programTypeId: number): Observable<MarketingBanner> {
    return this.http.get<MarketingBanner>(
      `${this.settings.baseUrl}/api/Notification/GetMarketingBanner/${programTypeId}`
    );
  }

  updateMarketingBanner(
    marketingBannerMessage: MarketingBannerMessage
  ): Observable<string> {
    return this.http.post<string>(
      `${this.settings.baseUrl}/api/Notification/UpdateMarketingBanner`,
      marketingBannerMessage
    );
  }

  getNotificationBannerHistory(
    programTypeId: number
  ): Observable<NotificationBannerHistory[]> {
    return this.http.get<NotificationBannerHistory[]>(
      `${this.settings.baseUrl}/api/Notification/GetNotificationHistory?programTypeId=${programTypeId}`
    );
  }

  getMarketingnBannerHistory(
    programTypeId: number
  ): Observable<MarketingBannerHistory[]> {
    return this.http.get<MarketingBannerHistory[]>(
      `${this.settings.baseUrl}/api/Notification/GetMarketingBannerHistory/${programTypeId}`
    );
  }

  getIncentiveCountRequiringAction(): Observable<EngagmentCountModel> {
    return this.http.get<EngagmentCountModel>(
      `${this.settings.baseUrl}api/M365acceleratorNominations/GetIncentiveCountRequiringAction`
    );
  }

  getDealAssociationDocumentsForAdvisorIncentives(): Observable<
    PartnerInput[]
  > {
    return this.http.get<PartnerInput[]>(
      `${this.settings.baseUrl}api/M365acceleratorNominations/GetDealAssociationDocumentsForAdvisorIncentives`
    );
  }

  getPartnerBulkEmailHistory(): Observable<PartnerBulkEmailTracking[]> {
    return this.http.get<PartnerBulkEmailTracking[]>(
      `${this.settings.baseUrl}api/Notification/GetBulkPartnerEmailHistory`
    );
  }

  GetPartnerEmailTemplate(): Observable<PartnerEmailTemplate[]> {
    return this.http.get<PartnerEmailTemplate[]>(
      `${this.settings.baseUrl}api/Notification/GetPartnerEmailTemplate`
    );
  }
  GetRecipientCategory(): Observable<RecipientCategory[]> {
    return this.http.get<RecipientCategory[]>(
      `${this.settings.baseUrl}api/Notification/GetRecipientCategory`
    );
  }
  getEmailTemplate(templateId: number): Observable<EmailBroadCast> {
    return this.http.get<EmailBroadCast>(
      `${this.settings.baseUrl}api/Notification/GetEmailTemplate/${templateId}`
    );
  }
  sendEmailTemplate(input: EmailBroadCastInput): Observable<string> {
    return this.http.post<string>(
      `${this.settings.baseUrl}api/Notification/SendEmailTemplate`,
      input
    );
  }
  GetEmailTemplateDetails(
    templateId: number
  ): Observable<PartnerBulkEmailTemplateDetails> {
    return this.http.get<PartnerBulkEmailTemplateDetails>(
      `${this.settings.baseUrl}api/Notification/GetEmailTemplateDetails/${templateId}`
    );
  }
  UpdateEmailTemplateDetail(
    input: PartnerBulkEmailTemplateDetails
  ): Observable<string> {
    return this.http.post<string>(
      `${this.settings.baseUrl}api/Notification/UpdateEmailTemplateDetail`,
      input
    );
  }
  getPartnerBulkEmailExportData(emailBatchId: number) {
    return this.http.get(
      `${this.settings.baseUrl}api/Notification/ExportEmailHistory/${emailBatchId}`,
      { responseType: 'blob' }
    );
  }
}
